import { render, staticRenderFns } from "./DuplicateModal.vue?vue&type=template&id=13a6e06f&scoped=true&"
import script from "./DuplicateModal.vue?vue&type=script&lang=ts&"
export * from "./DuplicateModal.vue?vue&type=script&lang=ts&"
import style0 from "./DuplicateModal.vue?vue&type=style&index=0&id=13a6e06f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a6e06f",
  null
  
)

export default component.exports